import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class GetFriendsInAppApi {
    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async getFriendsInApp() {
        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            if (authenticationResponse == null) {
                return undefined;
            }

            const response = await axios.get(
                `${this.authClient.getApiRoot()}/user/appFriends`,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                data: response.data

            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage
            };
        }
    }
}

export default GetFriendsInAppApi;